<template>
  <div class="menu-list">
    <el-table
      ref="multipleTable"
      :data="menuData"
      tooltip-effect="dark"
      style="width: 100%"
      class="common-edit-button"
      row-key="id"
      :tree-props="{ children: 'childMenu', hasChildren: 'hasChildren' }"
      height="calc(100vh - 220px)"
    >
      <!-- <el-table-column label="#" type="index"> </el-table-column> -->
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->
      <el-table-column
        prop="menuName"
        label="菜单名称"
        :show-overflow-tooltip="true"
        width="200px"
      >
      </el-table-column>
      <el-table-column prop="orderNum" label="显示顺序" :show-overflow-tooltip="true">
      </el-table-column>
      <!-- <el-table-column
        prop="title"
        label="图标"
        :show-overflow-tooltip="true"
      >
      <template slot-scope="scope">
          <i class="iconfont" :class="`icon-${scope.row.icon}`"></i>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="150px">
        <template slot-scope="scope">
          <div class="handle-container">
            <!-- 修改 -->
            <el-button
              type="warning"
              icon="el-icon-edit"
              @click="editMenu(scope.row)"
              v-hasPermi="'sc:schoolmenu:edit'"
              size="small"
            >修改
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 修改宿舍信息 -->
    <editMenu
      :editShow.sync="editShow"
      v-if="editShow"
      :menuInfo="menuInfo"
      :menuList="menuData"
    />
  </div>
</template>

<script>
import editMenu from "../edit-menu/editMenu.vue";
export default {
  data() {
    return {
      selectList: [],
      menuInfo: null,
      editShow: false,
    };
  },
  // inject: ["refresh"],
  props: {
    menuData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {
    editMenu,
  },
  created() {},
  methods: {
    addMenu(e) {},
    editMenu(e) {
      this.menuInfo = e;
      this.editShow = true;
    },
  },
};
</script>

<style>
@import "./menuList.scss";
</style>
